import Button from 'components/Button/Button'
import {
  TableItemBody,
  TableItemContainer,
} from 'components/Table/Table.styled'
import { Text } from 'components/Text'
import React, { useState } from 'react'
import ExternalProgramModal from '../ExternalProgramModal'
import { ProgramItemProps } from './ProgramItem.props'

export const ProgramItem: React.FC<ProgramItemProps> = ({
  program,
  locationId,
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false)
  return (
    <>
      <TableItemContainer>
        <TableItemBody>
          <Text>{program.name}</Text>
        </TableItemBody>
        <TableItemBody>
          <Button
            preset={'ghost'}
            variant={'primary'}
            text={'View program'}
            size={'small'}
            onClick={() => setOpenModal(!openModal)}
          />
        </TableItemBody>
      </TableItemContainer>
      {openModal && (
        <ExternalProgramModal
          onClose={() => setOpenModal(!openModal)}
          programId={program.id}
          locationId={locationId}
        />
      )}
    </>
  )
}
